import { Component, OnInit } from '@angular/core';
import { LoginService } from "../login/login.service";
import { Funcoes } from "../funcoes";
import { Router } from "@angular/router";
import { Global } from "../global";
import { ConfiguracoesService } from "../configuracoes/configuracoes.service";

declare var $: any;

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  logoPainelUrl: string = '';

  constructor(
    private func: Funcoes,
    private router: Router,
    public global: Global,
    private configService: ConfiguracoesService,
    private loginService: LoginService
  ) {
    if (this.func.getTokenInfo()['adm'] != 1) {
      this.loginService.getUserInfo().subscribe(
        data => {
          let isTipo8 = false;
          if (data && data.cliente && data.cliente.tipos) {
            isTipo8 = data.cliente.tipos.some(t => String(t.id_tipo) === '8');
          }
          if (isTipo8) {
            this.router.navigate(['/painel/area-cliente/meus-testes-sopro']);
          } else {
            this.router.navigate(['/painel/area-cliente/minhas-fichas']);
          }
        },
        () => {
          this.router.navigate(['/painel/area-cliente/minhas-fichas']);
        }
      );
    } else {
      this.router.navigate(['/painel/dashboard']);
    }
  }

  ngOnInit() {
    this.carregarConfiguracoes();
  }

  carregarConfiguracoes() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload) {
          let item = Array.isArray(json.Payload[0])
            ? json.Payload[0][0]
            : (Array.isArray(json.Payload) ? json.Payload[0] : json.Payload);
          if (item) {
            let logo = item.logo_dashboard || item.logo_painel || item.logo_pdf;
            if (logo && !logo.includes('fakepath') && !logo.includes('C:')) {
              this.logoPainelUrl = logo.startsWith('http') ? logo : (logo.startsWith('/') ? this.global.dominio_site + logo : this.global.dominio_site + '/' + logo);
            }
          }
        }
      },
      error => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts